<template>
  <div class="record-btn">
    <div @click="openRecord" class="record-trigger" :class="{ 'active': recordPopover }">
      <span class="record-text">
        受理记录
        <i class="el-icon-arrow-up" :class="{ 'rotate': recordPopover }"></i>
      </span>
      <img class="record-icon" src="@/assets/images/icon/record.png" alt="受理记录图标" />
    </div>

    <div class="record-popover" :class="{ 'visible': recordPopover }">
      <div class="popover-arrow"></div>
      <div class="record-list" v-loading="logLoading">
        <el-timeline v-if="activities.length > 0">
          <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="timelineColor(activity).icon"
            :type="timelineColor(activity).type" :timestamp="activity.operationTime" class="timeline-item">
            <div class="timeline-content">
              <div class="timeline-header">
                <span :style="{ color: activity.color }" class="action-name">
                  {{ activity.actionName }}
                </span>
                <span class="operator-name">{{ activity.operatorName }}</span>
              </div>
              <div class="timeline-opinion">{{ activity.opinion }}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <template v-if="activities.length === 0">
          <JjEmpty :msg="'暂无受理记录'"></JjEmpty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { logRecord } from "@/api/public";
export default {
  name: "JjLogRecord",
  components: {},
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activities: [],
      logLoading: false,
      recordPopover: false
    };
  },
  created() { },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    closeRecord() {
      this.recordPopover = false;
    },
    openRecord() {
      this.recordPopover = !this.recordPopover;
      if (this.recordPopover) this.getLogRecord();
    },
    async getLogRecord() {
      this.logLoading = true;
      let { code, data } = await logRecord(this.id);
      if (code === 200) {
        this.logLoading = false;
        this.activities = data;
      } else {
        this.logLoading = false;
      }
    },
    timelineColor(item) {
      switch (item.action) {
        case "submit":
          item.type = "primary";
          item.icon = "el-icon-s-promotion";
          item.color = "#409EFF";
          break;
        case "back":
          item.type = "danger";
          item.icon = "el-icon-close";
          item.color = "#F56C6C";
          break;
        case "pass":
          item.type = "success";
          item.icon = "el-icon-s-check";
          item.color = "#67C23A";
          break;
        case "revoke":
          item.type = "warning";
          item.icon = "el-icon-refresh";
          item.color = "#E6A23C";
          break;
        case "unarchive":
          item.type = "danger";
          item.icon = "el-icon-refresh-left";
          item.color = "#E6A23C";
          break;
      }
      return item;
    }
  }
};
</script>

<style scoped lang="scss">
// 受理记录组件样式
.record-btn {
  position: relative;
  margin-right: 20px;
  z-index: 100;
}

// 触发按钮样式
.record-trigger {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #409eff;
  background: linear-gradient(135deg, #e6f0ff, #d1e4ff);
  padding: 6px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);

  &:hover {
    background: linear-gradient(135deg, #d1e4ff, #adc6ff);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }

  &.active {
    background: linear-gradient(135deg, #409eff, #69b1ff);
    color: #fff;
  }
}

.record-text {
  display: flex;
  align-items: center;
  margin-right: 10px;
  white-space: nowrap;
}

.el-icon-arrow-up {
  margin-left: 6px;
  transition: transform 0.3s ease;
  font-size: 14px;
}

.rotate {
  transform: rotate(180deg);
}

.record-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  transition: transform 0.3s ease;

  .record-trigger.active & {
    transform: scale(1.1);
  }
}

// 弹出层样式
.record-popover {
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  min-width: 420px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 99;

  &.visible {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

// 弹出层箭头
.popover-arrow {
  position: absolute;
  bottom: -10px;
  right: 24px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
}

// 记录列表样式
.record-list {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease;

  .record-popover.visible & {
    max-height: 73vh;
    overflow-y: auto;
    padding: 20px 24px;
  }

  // 滚动条美化
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;

    &:hover {
      background: #c0c4cc;
    }
  }
}

// 时间线样式
.timeline-item {
  position: relative;
  padding-bottom: 24px;

  &:last-child {
    padding-bottom: 0;
  }

  ::v-deep & .el-timeline-item__node {
    width: 24px;
    height: 24px;
    font-size: 14px;
    box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.1);
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  ::v-deep & .el-timeline-item__tail {
    left: 11px;
    width: 2px;
  }

  ::v-deep & .el-timeline-item__timestamp {
    color: #8c8c8c;
    font-size: 12px;
    margin-bottom: 6px;
    font-weight: 500;
  }

  ::v-deep & .el-timeline-item__wrapper {
    padding-left: 32px;
  }
}

.timeline-content {
  background-color: #f7f8fa;
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f2f5;
    transform: translateX(2px);
  }
}

.timeline-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.action-name {
  font-weight: 600;
  font-size: 14px;
}

.operator-name {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
  white-space: nowrap;
}

.timeline-opinion {
  color: #333;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-word;
}

// 适配小屏幕
@media (max-width: 768px) {
  .record-popover {
    min-width: 300px;
    left: 50%;
    transform: translateX(50%) translateY(10px);

    &.visible {
      transform: translateX(50%) translateY(0);
    }
  }

  .popover-arrow {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
